<template>
  <PulseLoader class="h-full flex justify-center items-center" color="#f44336"></PulseLoader>
</template>
